import React from 'react';

import useTranslation from '../../features/locale/useTranslation';
import { Icon } from '../Icon';
import { IconButton, type IconButtonProps } from '../IconButton';
import { Tooltip } from '../Tooltip';

export type FormControlClearButtonProps = Omit<IconButtonProps, 'type' | 'color' | 'children'>;

export const FormControlClearButton = (props: FormControlClearButtonProps) => {
    const { t } = useTranslation();
    return (
        <Tooltip title={t('Clear')}>
            <IconButton
                size="small"
                color="neutral"
                type="ghost"
                aria-label="clear value"
                data-testid="form-control-clear-button"
                {...props}
            >
                <Icon name="s-icon-xmark" size="medium" />
            </IconButton>
        </Tooltip>
    );
};
